module.exports = __webpack_public_path__ + "site/img/41.78a5f93c.jpg";